<template>
  <modal
    :showOkay="false"
    id="error-response-modal"
    :showClose="errorMessageExist"
    :showExit="false"
  >
    <template v-slot:title>
      <template v-if="!errorMessageExist">
        Session lost
      </template>
      <template v-else>
        Oops!
      </template>
    </template>

    <template v-slot:body>
      <div>
        <template v-if="!errorMessageExist">
          <p>
            It looks like you're not connected to the internet. Please re-connect and refresh this
            page.
          </p>
        </template>
        <template v-else>
          {{ errors.message }}
        </template>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@shared/Modal.vue';

  export default {
    components: {
      Modal,
    },
    props: {
      errors: {
        type: Object,
        required: false,
      },
    },
    computed: {
      errorMessageExist() {
        return Object.keys(this.errors).length === 0;
      },
    },
  };
</script>
